import { IUser } from '@/types/user'
import jwtDecode from 'jwt-decode'
import router from '@/router'
import store from '@/store'
import authenticationLocalStorageService from './authentication-local-storage.service'

export class AuthenticationService {

  public existUserCredentials(): boolean {
    return !!authenticationLocalStorageService.user
  }

  public authenticateUser() {
    // tslint:disable:no-string-literal
    const apiUrl = store.getters['parameters']('apiUrl')
    window.location.href = `${apiUrl}/v0/authentication`
  }

  public existUserData(): boolean {
    return !!store.getters.user
  }

  public setUserDataFromToken(token: string) {
    let user: any
    try {
      user = jwtDecode(token)
      this.setUserAndTokenInLocalStorage(user, token)
      this.setUserInStore(user)
    } catch (exception) {
      console.error('An error occured while decoding JWT token', exception)
    }
  }

  public setUserDataFromLocalStorage() {
    const user = authenticationLocalStorageService.user

    if (user) {
      this.setUserInStore(user)
    }
  }

  public setUserAndTokenInLocalStorage(user: IUser, token: string) {
    if (user) {
      authenticationLocalStorageService.user = user
      authenticationLocalStorageService.token = token
    }
  }

  public setUserInStore(user: IUser) {
    store.dispatch('setUser', user)
  }

  public redirectToPrevLocation() {
    const prevLocationPath = authenticationLocalStorageService.prevLocation.fullPath || ''
    router.replace({ path: prevLocationPath })
  }

  public saveCurrentLocationAsPrev(currentLocation: any) {
    authenticationLocalStorageService.prevLocation = currentLocation
  }

}

export default new AuthenticationService()
